import _implicitStylesheets from "./home.css";
import _implicitScopedStylesheets from "./home.scoped.css?scoped=true";
import _discoveryLoginMotivation from "discovery/loginMotivation";
import _aceInstalls from "ace/installs";
import _discoveryBlazeYourTrail from "discovery/blazeYourTrail";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "home-container-inner": true
  },
  attrs: {
    "grid": "",
    "axis": "column"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "toast": true
  },
  attrs: {
    "data-position": "0"
  },
  key: 1
};
const stc2 = {
  key: 2
};
const stc3 = {
  attrs: {
    "data-position": "19"
  },
  key: 6
};
const stc4 = {
  key: 7
};
const stc5 = {
  attrs: {
    "data-position": "20"
  },
  key: 8
};
const stc6 = {
  key: 9
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, ncls: api_normalize_class_name, k: api_key, ddc: api_deprecated_dynamic_component, i: api_iterator, f: api_flatten} = $api;
  return [api_element("main", stc0, api_flatten([api_element("section", stc1, [api_custom_element("discovery-login-motivation", _discoveryLoginMotivation, stc2)]), api_iterator($cmp.sections, function (section) {
    return api_element("section", {
      className: api_normalize_class_name(section.type),
      attrs: {
        "data-position": section.props.positions
      },
      key: api_key(3, section.key)
    }, [!section.props.spreadProps ? api_deprecated_dynamic_component("home-section", section.constructor, {
      props: {
        "props": section.props,
        ...section.spreadProps
      },
      key: 4
    }) : null, section.props.spreadProps ? api_deprecated_dynamic_component("home-section", section.constructor, {
      props: {
        ...section.props.spreadProps
      },
      key: 5
    }) : null]);
  }), api_element("section", stc3, [api_custom_element("ace-installs", _aceInstalls, stc4)]), api_element("section", stc5, [api_custom_element("discovery-blaze-your-trail", _discoveryBlazeYourTrail, stc6)])]))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4sru1qf14b2";
tmpl.legacyStylesheetToken = "undefined-_home";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
